import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import skillookAdmin from 'apis/skillookAdmin';
import { mapKeys, omit } from 'lodash';

// First, create the thunk

// Get All Categories Request

export const allCategoriesListRequest = createAsyncThunk(
  'allCategoriesList',
  async body => {
    const [start, limit] = body;
    const response = await skillookAdmin.get(
      `admin/users/categories/allCategoryNames?limit=${limit}&skip=${start}`
    );
    return response.data.data;
  }
);

// Search All Categories Request

export const searchCategoriesListRequest = createAsyncThunk(
  'searchCategoriesList',
  async body => {
    const [keyword, start, limit] = body;
    const response = await skillookAdmin.get(
      `admin/users/categories/search?limit=${limit}&skip=${start}&keyword=${keyword}`
    );
    return { skip: start, data: response.data.data };
  }
);

// Add New Categories

export const addNewCategoryRequest = createAsyncThunk(
  'addNewCategory',
  async body => {
    const response = await skillookAdmin.post(
      `admin/users/categories/addCategoryName`,
      body
    );
    return response.data.data;
  }
);

// Get Single Category Details

export const getSingleCategoryRequest = createAsyncThunk(
  'getSingleCategory',
  async body => {
    const response = await skillookAdmin.post(
      `admin/users/categories/singleCategoryName`,
      body
    );
    return response.data.data;
  }
);

// Delete Category Request

export const deleteCategoryRequest = createAsyncThunk(
  'deleteCategory',
  async body => {
    await skillookAdmin.post('admin/users/categories/deleteCategoryName', body);
    return body.id;
  }
);

// Update Category Name

export const updateCategoryRequest = createAsyncThunk(
  'updateCategory',
  async body => {
    await skillookAdmin.post('admin/users/categories/updateCategoryName', body);
    return body;
  }
);

// Then, handle actions in your reducers:
const categoriesListSlice = createSlice({
  name: 'allCategoriesList',
  initialState: { list: {}, totalCount: 0, singleCategory: null },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    emptyAllCategoryList() {
      return {};
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [allCategoriesListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: { ...state.list, ...mapKeys(action.payload.categoryList, '_id') },
        totalCount: action.payload.totalCategoriesCount,
      };
    },
    [searchCategoriesListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list:
          action.payload.skip === 0
            ? { ...mapKeys(action.payload.data.categoryList, '_id') }
            : {
                ...state.list,
                ...mapKeys(action.payload.data.categoryList, '_id'),
              },
        totalCount: action.payload.data.totalCategoriesCount,
      };
    },
    [getSingleCategoryRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        singleCategory: action.payload,
      };
    },
    [addNewCategoryRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: {
          ...state.list,
          [action.payload._id]: {
            _id: action.payload._id,
            categoryName: action.payload.category,
          },
        },
      };
    },
    [deleteCategoryRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: omit(state.list, action.payload),
        singleCategory: null,
      };
    },
    [updateCategoryRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: {
          ...state.list,
          [action.payload.id]: {
            ...state.list[action.payload.id],
            categoryName: action.payload.category,
          },
        },
      };
    },
  },
});

export const { emptyAllCategoryList } = categoriesListSlice.actions;
export default categoriesListSlice.reducer;
